import CTeService from "@/services/CTeService";

export const cte = {
  namespaced: true,
  state: {
    cte: {},
  },
  actions: {
    getCTe({ commit }, payload) {
      return CTeService.GetCTe(payload).then(
        (cte) => Promise.resolve(cte),
        (error) => Promise.reject(error.response.data)
      );
    },
    postCTe({ commit }, payload) {
      return CTeService.PostCTe(payload).then(
        (cte) => Promise.resolve(cte),
        (error) => Promise.reject(error.response.data)
      );
    },
    putCTe({ commit }, payload) {
      return CTeService.PutCTe(payload).then(
        (cte) => Promise.resolve(cte),
        (error) => Promise.reject(error.response.data)
      );
    },
    deleteCTe({ commit }, payload) {
      return CTeService.DeleteCTe(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    getCTeOData({ commit }, payload) {
      return CTeService.GetCTeOData(payload).then(
        (cte) => Promise.resolve(cte),
        (error) => Promise.reject(error)
      );
    },
  },
  mutations: {},
};

export default cte;
